var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8885 37.5718V24.3125L15.4688 28.7323",
    stroke: "#FF669B",
    strokeWidth: 3.31481,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8906 24.3125L24.3104 28.7323",
    stroke: "#FF669B",
    strokeWidth: 3.31481,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6194 22.1009V33.1503C48.6194 44.1997 44.1997 48.6194 33.1503 48.6194H19.891C8.84163 48.6194 4.42188 44.1997 4.42188 33.1503V19.891C4.42188 8.84163 8.84163 4.42188 19.891 4.42188H30.9404",
    stroke: "#FF669B",
    strokeWidth: 3.31481,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6165 22.1009H39.777C33.1474 22.1009 30.9375 19.891 30.9375 13.2614V4.42188L48.6165 22.1009Z",
    stroke: "#FF669B",
    strokeWidth: 3.31481,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoUpload);
export default __webpack_public_path__ + "static/media/LogoUpload.7fe7e9694901da0d96282cd6d70bac84.svg";
export { ForwardRef as ReactComponent };